import { CART_CLEAR } from 'constants/actionType'

export const removeCheckoutItems = ({ app }) => {
  app.dispatch({ type: CART_CLEAR })
}
